<ng-container *transloco="let t; read: 'deviceConfig'">
  <app-grid-page [title]="t('title')">
    <app-grid
      [columns]="columns()"
      [data]="configurations()"
      [rowId]="configId"
      [loading]="isLoading()"
      [page]="page()"
      [pageSize]="size()"
      [totalElements]="totalElements()"
      [totalPages]="totalPages()"
      [sort]="sort()"
      [searchable]="true"
      [exportable]="true"
      [detailEnabled]="true"
      [primaryAction]="{ label: t('addConfig'), icon: 'icon-content-add24px' }"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (rowClick)="onRowClick(asConfig($event))"
      (rowDblClick)="editConfiguration(asConfig($event))"
      (primaryActionClick)="openAddDeviceConfigurationDialog()"
    >
      <ng-template gridDetail let-row>
        @let config = asConfig(row);
        <div class="font-display text-xl font-bold text-ink-1">{{ config.name }}</div>
        <div class="mb-4 text-sm text-ink-3">{{ t('detail.id') }} {{ config.id }}</div>

        <div class="border-t border-hairline">
          <div class="flex items-center justify-between border-b border-hairline py-3">
            <span class="text-[13px] text-ink-3">{{ t('detail.timezone') }}</span>
            <span class="text-[13px] font-semibold text-ink-1">{{ config.timezone || t('na') }}</span>
          </div>
          <div class="flex items-center justify-between border-b border-hairline py-3">
            <span class="text-[13px] text-ink-3">{{ t('detail.resolution') }}</span>
            <span class="text-[13px] font-semibold text-ink-1">{{ resolution(config) }}</span>
          </div>
          <div class="flex items-center justify-between border-b border-hairline py-3">
            <span class="text-[13px] text-ink-3">{{ t('detail.timeSyncUrl') }}</span>
            <span class="max-w-[200px] truncate text-[13px] font-semibold text-ink-1">{{ config.timeSyncUrl || t('na') }}</span>
          </div>
          <div class="flex items-center justify-between border-b border-hairline py-3">
            <span class="text-[13px] text-ink-3">{{ t('detail.displayPorts') }}</span>
            <span class="text-[13px] font-semibold text-ink-1">{{ displayPortCount(config) }}</span>
          </div>
          <div class="flex items-center justify-between border-b border-hairline py-3">
            <span class="text-[13px] text-ink-3">{{ t('detail.lastUpdated') }}</span>
            <span class="text-[13px] font-semibold text-ink-1">{{ config.lastUpdated | date: 'medium' }}</span>
          </div>
        </div>

        <div class="mt-5">
          <button
            type="button"
            (click)="editConfiguration(config)"
            class="w-full rounded-control bg-action px-3 py-2.5 text-[13px] font-semibold text-action-text hover:brightness-90"
          >
            {{ t('actions.edit') }}
          </button>
        </div>
      </ng-template>
    </app-grid>
  </app-grid-page>

  @if (isDialogOpen()) {
    <device-configuration-view
      [isOpen]="isDialogOpen()"
      [mode]="dialogMode()"
      [viewOrEditDeviceConfigurationDto]="currentConfiguration()"
      (configurationSaved)="handleConfigurationSaved($event)"
      (configurationUpdated)="handleConfigurationUpdated($event)"
      (dialogClosed)="closeAddDeviceConfigurationDialog()"
    ></device-configuration-view>
  }
</ng-container>
